import React from 'react';
import ReactDOM from 'react-dom';
import { X, Copy, CheckCircle2, UserCheck } from 'lucide-react';

const ShareModal = ({ 
  show, 
  onClose, 
  eventToShare,
  shareRecipients,
  setShareRecipients,
  followersList,
  friendsList,
  handleShareSubmit
}) => {
  if (!show) return null;
  
  return ReactDOM.createPortal(
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.9)',
            backdropFilter: 'blur(8px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10004,
            padding: '1rem'
          }}
          onClick={() => onClose()}
        >
          <div
            style={{
              width: '90%',
              maxWidth: '600px',
              maxHeight: '80vh',
              background: 'rgba(26, 26, 46, 0.98)',
              borderRadius: '16px',
              overflow: 'hidden',
              border: '3px solid #ffa500',
              display: 'flex',
              flexDirection: 'column'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Share Header */}
            <div style={{
              padding: '1.5rem',
              borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
              flexShrink: 0
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h2 style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#fff',
                    margin: '0 0 0.5rem 0'
                  }}>
                    Share Event
                  </h2>
                  <p style={{
                    fontSize: '0.9rem',
                    color: 'rgba(255, 255, 255, 0.6)',
                    margin: 0
                  }}>
                    {eventToShare.event_name}
                  </p>
                </div>
                <button
                  onClick={() => onClose()}
                  style={{
                    background: 'rgba(255, 0, 128, 0.2)',
                    border: '1px solid rgba(255, 0, 128, 0.4)',
                    color: '#ff0080',
                    width: '32px',
                    height: '32px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.25rem',
                    cursor: 'pointer',
                    flexShrink: 0
                  }}
                >
                  <X size={18} />
                </button>
              </div>
            </div>

            {/* Share Content */}
            <div
              style={{
                padding: '1.5rem',
                overflowY: 'auto',
                flex: 1
              }}
            >
              {(followersList.length === 0 && friendsList.length === 0) ? (
                <div style={{ textAlign: 'center', padding: '2rem', color: 'rgba(255, 255, 255, 0.6)' }}>
                  You don't have any followers or friends yet to share with.
                </div>
              ) : (
                <div>
                  {/* Friends Section */}
                  {friendsList.length > 0 && (
                    <div style={{ marginBottom: '2rem' }}>
                      <h3 style={{ fontSize: '1.1rem', color: '#fff', marginBottom: '1rem' }}>Friends</h3>
                      {friendsList.map(friend => {
                        const friendUserId = friend.from_user_id === JSON.parse(localStorage.getItem('user') || '{}').id 
                          ? friend.to_user_id 
                          : friend.from_user_id;
                        const isSelected = shareRecipients.includes(friendUserId);
                        
                        return (
                          <div
                            key={friend.id}
                            onClick={() => {
                              if (isSelected) {
                                setShareRecipients(shareRecipients.filter(id => id !== friendUserId));
                              } else {
                                setShareRecipients([...shareRecipients, friendUserId]);
                              }
                            }}
                            style={{
                              padding: '1rem',
                              background: isSelected ? 'rgba(0, 255, 0, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                              border: `1px solid ${isSelected ? 'rgba(0, 255, 0, 0.4)' : 'rgba(255, 255, 255, 0.1)'}`,
                              borderRadius: '8px',
                              marginBottom: '0.5rem',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '1rem'
                            }}
                          >
                            <div style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              background: 'linear-gradient(135deg, #00ff00, #00ffff)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              👤
                            </div>
                            <div style={{ flex: 1 }}>
                              <p style={{ color: '#fff', margin: 0, fontWeight: '600' }}>
                                Friend {friendUserId.substring(0, 8)}
                              </p>
                            </div>
                            {isSelected && <UserCheck size={20} color="#00ff00" />}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* Followers Section */}
                  {followersList.length > 0 && (
                    <div>
                      <h3 style={{ fontSize: '1.1rem', color: '#fff', marginBottom: '1rem' }}>Followers</h3>
                      {followersList.map(follower => {
                        const isSelected = shareRecipients.includes(follower.from_user_id);
                        
                        return (
                          <div
                            key={follower.id}
                            onClick={() => {
                              if (isSelected) {
                                setShareRecipients(shareRecipients.filter(id => id !== follower.from_user_id));
                              } else {
                                setShareRecipients([...shareRecipients, follower.from_user_id]);
                              }
                            }}
                            style={{
                              padding: '1rem',
                              background: isSelected ? 'rgba(0, 255, 255, 0.15)' : 'rgba(255, 255, 255, 0.05)',
                              border: `1px solid ${isSelected ? 'rgba(0, 255, 255, 0.4)' : 'rgba(255, 255, 255, 0.1)'}`,
                              borderRadius: '8px',
                              marginBottom: '0.5rem',
                              cursor: 'pointer',
                              transition: 'all 0.2s ease',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '1rem'
                            }}
                          >
                            <div style={{
                              width: '40px',
                              height: '40px',
                              borderRadius: '50%',
                              background: 'linear-gradient(135deg, #00ffff, #ff00ff)',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              👤
                            </div>
                            <div style={{ flex: 1 }}>
                              <p style={{ color: '#fff', margin: 0, fontWeight: '600' }}>
                                Follower {follower.from_user_id.substring(0, 8)}
                              </p>
                            </div>
                            {isSelected && <UserCheck size={20} color="#00ffff" />}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Share Footer */}
            <div style={{
              padding: '1.5rem',
              borderTop: '1px solid rgba(255, 255, 255, 0.1)',
              flexShrink: 0
            }}>
              <button
                onClick={handleShareSubmit}
                disabled={shareRecipients.length === 0}
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  background: shareRecipients.length > 0 ? 'rgba(255, 165, 0, 0.2)' : 'rgba(255, 255, 255, 0.1)',
                  border: `1px solid ${shareRecipients.length > 0 ? 'rgba(255, 165, 0, 0.4)' : 'rgba(255, 255, 255, 0.2)'}`,
                  borderRadius: '8px',
                  color: shareRecipients.length > 0 ? '#ffa500' : 'rgba(255, 255, 255, 0.4)',
                  fontSize: '1rem',
                  fontWeight: '600',
                  cursor: shareRecipients.length > 0 ? 'pointer' : 'not-allowed',
                  transition: 'all 0.2s ease'
                }}
              >
                Share with {shareRecipients.length} {shareRecipients.length === 1 ? 'person' : 'people'}
              </button>
            </div>
          </div>
        </div>,
    document.body
  );
};

export default ShareModal;
